
    import Vue from 'vue';
    import signup from '@/api/signup';
    import { ConfigType } from '@/types/events';
    import { SignupProgressStateEnum } from '@/types/enum';
    import { DataProvider } from '@/api/signup/interface';
    import AsModal from '@/components/Ui/AsModal.vue';
    import AppContent from '@/components/Layout/AppContent.vue';    
    import settingsHelper from '@/store/modules/settings/helper';
    import signupHelper from '@/store/modules/signup/helper';
    import navigationHelper from '@/store/modules/navigation/helper';
    import { SystemPagesEnum } from '@/util/signup';
    import { getReasons, getTransactionTimeFrame } from '@/util/consent';
    import { Dictionary } from 'vuex';
    import { i18nTemplateString } from '@/util/i18n';
    import { consentCancelled } from '@/util/messages';

    const settingsHelpers = settingsHelper.mapGetters(['client', 'textOverrides', 'accessReason', 'daysOfTransactions', 'providers']);
    const signupHelpers = signupHelper.mapGetters(['cancelUrl']);

    export default Vue.extend({
        name: 'Deny',
        components: {
            AsModal,
            AppContent
        },
        computed: {
            ...settingsHelpers,
            ...signupHelpers,
            hasCancelUrl(): boolean {
                return !!this.cancelUrl;
            },
            overrides(): Dictionary<string> {
                return this.textOverrides.deny || {};
            },
            title(): string {
                return this.overrides.title !== undefined ? this.overrides.title : i18nTemplateString('{i18n.denyModal.title}', (x) => this.$t(x));
            },
            top(): string {
                let provider = this.providers.trueLayer ? 'Equifax UK' : 'consents.online';
                return this.overrides.top !== undefined
                    ? this.overrides.top
                    : i18nTemplateString('{i18n.denyModal.top}', (x) => this.$t(x))
                        .replace('${provider}', provider);
            },
            bottom(): string {
                return this.overrides.bottom !== undefined
                    ? this.overrides.bottom
                    : i18nTemplateString('{i18n.denyModal.bottom}', (x) => this.$t(x))
                        .replace('${this.client}', this.client);
            },
            transactionTimeFrame() {
                return getTransactionTimeFrame(this.daysOfTransactions) + ' days';
            },
            isTrueLayer(): boolean {
                return this.providers.trueLayer ? true : false
            },
            reasons(): string[] {
                if (this.overrides.top !== undefined) { return []; }

                return getReasons(this.accessReason, this.client, this.daysOfTransactions)
            }
        },
        methods: {
            ...navigationHelper.mapActions(['navigateTo']),
            ...signupHelper.mapActions(['getCancelUrl']),
            cancel() {
                signup.triggerWebHookEvent(ConfigType.ConsentsDeniedWebhook.toLocaleLowerCase());
                signup.customerProgress(SignupProgressStateEnum.ConsentsDeclined);
                consentCancelled();
                if (this.hasCancelUrl) {
                    setTimeout(() => { top.location.href = this.cancelUrl || ''; }, 500);
                }
                else {
                    this.navigateTo(SystemPagesEnum.Declined);
                }
                this.$emit('close');
            },
            consent() {
                this.$emit('close');
            },
        },
        beforeMount() {
            this.$doWork(async () => {
                await this.getCancelUrl();
            });
        },
    });
